import { render, staticRenderFns } from "./TrxCreditIn.vue?vue&type=template&id=487caf9f"
import script from "./TrxCreditIn.vue?vue&type=script&lang=js"
export * from "./TrxCreditIn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports